"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("./constants");
var VIEWS = constants_1.default.VIEWS;
var global_error_1 = require("./common/global-error");
var extend_session_view_1 = require("./common/session/extend-session.view");
var placeholder_view_1 = require("./containers/placeholder.view");
var placeholder_view_2 = require("./containers/placeholder.view");
var placeholder_view_3 = require("./containers/placeholder.view");
var cookies_view_1 = require("./containers/cookies/cookies.view");
var cookiePrefs_view_1 = require("./containers/cookies/cookiePrefs.view");
var update_passport_view_1 = require("./containers/account/update-passport.view");
var update_name_view_1 = require("./containers/account/name/update-name.view");
var update_name_success_view_1 = require("./containers/account/name/update-name-success.view");
var update_name_minor_view_1 = require("./containers/account/name/update-name-minor.view");
var update_name_major_view_1 = require("./containers/account/name/update-name-major.view");
var update_name_legal_view_1 = require("./containers/account/name/update-name-legal.view");
var update_name_mail_files_view_1 = require("./containers/account/name/update-name-mail-files.view");
var update_passport_success_view_1 = require("./containers/account/update-passport-success.view");
var add_address_view_1 = require("./containers/account/address/add-address.view");
var ppc_edit_view_1 = require("./containers/account/address/ppc-edit.view");
var update_address_view_1 = require("./containers/account/address/update-address.view");
var remove_address_view_1 = require("./containers/account/address/remove-address.view");
var delete_passport_view_1 = require("./containers/account/delete-passport.view");
var delete_passport_success_view_1 = require("./containers/account/delete-passport-success.view");
var make_primary_view_1 = require("./containers/account/address/make-primary-view");
var manage_view_1 = require("./containers/account/address/manage.view");
var manage_phones_view_1 = require("./containers/account/phone/manage-phones.view");
var add_phone_view_1 = require("./containers/account/phone/add-phone.view");
var change_primary_phone_view_1 = require("./containers/account/phone/change-primary-phone.view");
var delete_phone_view_1 = require("./containers/account/phone/delete-phone.view");
var make_primary_phone_view_1 = require("./containers/account/phone/make-primary-phone.view");
var new_name_form_view_1 = require("./containers/account/name/new-name-form.view");
var name_change_reason_view_1 = require("./containers/account/name/name-change-reason.view");
var ppc_update_view_1 = require("./containers/account/ppc-update.view");
var validate_code_phone_view_1 = require("./containers/account/phone/validate-code-phone.view");
var update_occupation_view_1 = require("./containers/account/occupation/update-occupation.view");
var viewMap = {};
// Global views
viewMap[VIEWS.GLOBAL_ERROR] = { view: global_error_1.default };
viewMap[VIEWS.EXTEND_SESSION] = {
    view: extend_session_view_1.default,
    isCloseXHidden: true,
    isBackHidden: true,
};
viewMap[VIEWS.EMAILS.ADD] = {
    view: placeholder_view_1.default,
    isCloseXHidden: false,
    isBackHidden: true,
};
viewMap[VIEWS.EMAILS.EDIT] = {
    view: placeholder_view_2.default,
    isCloseXHidden: false,
    isBackHidden: true,
};
viewMap[VIEWS.UPDATE_PASSPORT] = {
    view: update_passport_view_1.default,
    isCloseXHidden: false,
    isBackHidden: true,
};
viewMap[VIEWS.UPDATE_PASSPORT_SUCCESS] = {
    view: update_passport_success_view_1.default,
    isCloseXHidden: false,
    isBackHidden: true,
};
viewMap[VIEWS.CHANGE_REASON] = {
    view: name_change_reason_view_1.default,
    isCloseXHidden: false,
    isBackHidden: {
        account: {
            name: {
                userCiped: true,
                stepUpPassed: false,
            },
        },
    },
};
viewMap[VIEWS.NEW_UPDATE_NAME] = {
    view: new_name_form_view_1.default,
    isCloseXHidden: false,
    isBackHidden: true,
};
viewMap[VIEWS.UPDATE_NAME] = {
    view: update_name_view_1.default,
    isCloseXHidden: false,
    isBackHidden: true,
};
viewMap[VIEWS.UPDATE_NAME_SUCCESS] = {
    view: update_name_success_view_1.default,
    isCloseXHidden: false,
    isBackHidden: true,
};
viewMap[VIEWS.MINOR_NAME_CHANGE] = {
    view: update_name_minor_view_1.default,
    isCloseXHidden: false,
    isBackHidden: false,
};
viewMap[VIEWS.MAJOR_NAME_CHANGE] = {
    view: update_name_major_view_1.default,
    isCloseXHidden: false,
    isBackHidden: false,
};
viewMap[VIEWS.LEGAL_NAME_CHANGE] = {
    view: update_name_legal_view_1.default,
    isCloseXHidden: false,
    isBackHidden: false,
};
viewMap[VIEWS.MAIL_FILES_NAME_CHANGE] = {
    view: update_name_mail_files_view_1.default,
    isCloseXHidden: false,
    isBackHidden: false,
};
viewMap[VIEWS.DELETE_PASSPORT] = {
    view: delete_passport_view_1.default,
    isCloseXHidden: false,
    isBackHidden: true,
};
viewMap[VIEWS.DELETE_PASSPORT_SUCCESS] = {
    view: delete_passport_success_view_1.default,
    isCloseXHidden: false,
    isBackHidden: true,
};
viewMap[VIEWS.NOTIFICATIONS] = {
    view: placeholder_view_3.default,
    isCloseXHidden: false,
    isBackHidden: true,
};
viewMap[VIEWS.COOKIES] = {
    view: cookies_view_1.default,
    isCloseXHidden: true,
    isBackHidden: true,
};
viewMap[VIEWS.COOKIE_PREFS] = {
    view: cookiePrefs_view_1.default,
    isCloseXHidden: false,
    isBackHidden: true,
};
viewMap[VIEWS.ADDRESSES.MAKE_PRIMARY] = {
    view: make_primary_view_1.default,
    isCloseXHidden: false,
    isBackHidden: false,
};
viewMap[VIEWS.ADDRESSES.MANAGE] = {
    view: manage_view_1.default,
    isCloseXHidden: false,
    isBackHidden: true,
};
viewMap[VIEWS.PHONES.MANAGE] = {
    view: manage_phones_view_1.default,
    isCloseXHidden: false,
    isBackHidden: true,
};
viewMap[VIEWS.PHONES.ADD] = {
    view: add_phone_view_1.default,
    isCloseXHidden: false,
    isBackHidden: true,
};
viewMap[VIEWS.PHONES.UPDATE] = {
    view: add_phone_view_1.default,
    isCloseXHidden: false,
    isBackHidden: false,
};
viewMap[VIEWS.PHONES.DELETE] = {
    view: delete_phone_view_1.default,
    isCloseXHidden: false,
    isBackHidden: false,
};
viewMap[VIEWS.PHONES.CHANGE_PRIMARY] = {
    view: change_primary_phone_view_1.default,
    isCloseXHidden: false,
    isBackHidden: false,
};
viewMap[VIEWS.PHONES.MAKE_PRIMARY] = {
    view: make_primary_phone_view_1.default,
    isCloseXHidden: false,
    isBackHidden: false,
};
viewMap[VIEWS.UPDATE_PPC] = {
    view: ppc_update_view_1.default,
    isCloseXHidden: false,
    isBackHidden: false,
};
viewMap[VIEWS.PHONES.VALIDATE_CODE] = {
    view: validate_code_phone_view_1.default,
    isCloseXHidden: false,
    isBackHidden: true,
};
viewMap[VIEWS.ADDRESSES.ADD] = {
    view: add_address_view_1.default,
    isCloseXHidden: false,
    isBackHidden: false,
};
viewMap[VIEWS.ADDRESSES.EDIT_PPC] = {
    view: ppc_edit_view_1.default,
    isCloseXHidden: false,
    isBackHidden: false,
};
viewMap[VIEWS.ADDRESSES.UPDATE] = {
    view: update_address_view_1.default,
    isCloseXHidden: false,
    isBackHidden: false,
};
viewMap[VIEWS.ADDRESSES.DELETE] = {
    view: remove_address_view_1.default,
    isCloseXHidden: false,
    isBackHidden: false,
};
viewMap[VIEWS.UPDATE_OCCUPATION] = {
    view: update_occupation_view_1.default,
    isCloseXHidden: false,
    isBackHidden: true,
};
exports.default = viewMap;
